export interface DischargeChecklistItem {
  id: string;
  label: string;
  position: number;
  groupTypeId: string;
  updatedAt: string;
  updatedByName: string | null;
}

// One per level of care with Discharge Planning on. `name` is the level of care's short name
// (SNF, LTC), which is what the tabs show.
export interface DischargeChecklist {
  groupType: { id: string; name: string };
  items: DischargeChecklistItem[];
}

export enum DischargeChecklistState {
  OPEN = 'open',
  DONE = 'done',
  NOT_NEEDED = 'not_needed',
}

// One item on a patient's checklist, with its label read live from configuration.
export interface DischargeChecklistEntry {
  itemId: string;
  label: string;
  state: DischargeChecklistState;
}

// A patient's checklist as the API sends it on their projected discharge review. `total` leaves out
// items marked not needed, so 5 items with 2 done and 1 not needed is done 2, total 4.
export interface DischargeChecklistSummary {
  done: number;
  total: number;
  items: DischargeChecklistEntry[];
}
